import React from 'react';
import '../../App.css';


const ComponentExperimentInformation = ({
    skill,
    isHoverType=true,
    customFontSize='14px'
}) => {
    return (
        <div
            style={{
                padding: '4px 14px',
                backgroundColor: (isHoverType) ? 'var(--common-back-green-deep2-color)' : 'var(--common-back-deep-color)',
                width: 'fit-content',
                textAlign: 'center',
                borderRadius: '18px',
                alignItems: 'center',
            }}
        >
            <div style={{
                position: 'relative',
                textAlign: 'center',
                width: '100%',
                alignSelf: 'flex-start',
                display: 'flex',
                alignItems: 'center',
                color: 'var(--common-main-color)',
                fontWeight: 'bold',
                justifyContent: 'center'
            }}>
                <span style={{
                    textAlign: 'center',
                    width: '100%',
                    fontSize: customFontSize,
                    color: (isHoverType) ? 'var(--common-main-green-deep-color)' : 'var(--common-main-color)'
                }}>
                    {skill}
                </span>
            </div>
        </div>
    );
};

export default ComponentExperimentInformation;